import { generateUtilityClasses } from '@mui/material';

import { TEXT_SHAPE_SIZE_MAP } from './constants';

export { TEXT_SHAPE_SIZE_MAP };

export const skeletonClasses = generateUtilityClasses('Skeleton', ['root']);
